
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";


export default function RuleEsp({rule, position, deleteClick}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{rule?.libdroit}</td>
            <td>{rule?.actiondroit}</td>
            {/* <td>{rule.libparent ? rule?.libparent : ""}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (rule?.etat === 1) ? 'badge-warning' :
                        (rule?.etat === 2) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {
                            (rule?.etat === 1) ? 'Non utilisé' : 
                            (rule?.etat === 2) ? 'Utilisé' : 
                            ''
                        }
                </div>
            </td>
            <td>{rule?.datecrea ? <ReactTimeAgo date={Date.parse(rule?.datecrea)} timeStyle="facebook" /> : ""}</td> */}
            <td className="text-center">
                <Link to={`/rule/${rule?.codedroit}`} data-toggle="tooltip" title="View privilege" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
                {(user?.isFullAction || user?.isFullActionNFC || user?.isDesaffecterDroitEspaceTravail) &&
                    <button onClick={deleteClick} data-toggle="tooltip" title="Remove privileges to this profile"  className="btn-shadow-danger mr-2 ml-2 btn btn-sm btn-danger">
                    <i className="fa fa-trash"></i>
                </button>}
            </td>
        </tr>
    )
}